import { motion } from 'framer-motion';
import { useCallback, useMemo } from 'react';

import { TemplatePlayer } from '../../types/team';

import { ItemAssistant, VariantsAssistance } from './ItemsAssistant';

import { usePlayerTemplateMap } from '@/hooks/usePlayer';
import { EquipoIdeal, ListaRepo } from '@/types/fieldAssistance';
import { EMPTY_TEMPLATE_PLAYER, FADE_IN_OUT } from '@/utils';

interface Props extends VariantsAssistance {
  equipoIdeal?: EquipoIdeal;
}

export const IdealTeamTable = ({ equipoIdeal, variant = 'DEFAULT' }: Props) => {
  const playerTemplateMap = usePlayerTemplateMap();

  const fieldPlayersMap = useMemo(() => {
    const map = new Map<number, ListaRepo>();
    equipoIdeal?.listaRepo?.forEach((player) => {
      map.set(player.idJT, player);
    });
    return map;
  }, [equipoIdeal]);

  const playersFiltered = useMemo(() => {
    if (!equipoIdeal?.listaRepo) return [];

    const players: TemplatePlayer[] = equipoIdeal.listaRepo.map((player) => {
      return playerTemplateMap.get(player.idJT) || EMPTY_TEMPLATE_PLAYER;
    });

    return players;
  }, [playerTemplateMap, equipoIdeal]);

  const getDataFieldPlayer = useCallback(
    (id: number): ListaRepo | undefined => {
      return fieldPlayersMap.get(id);
    },
    [fieldPlayersMap]
  );

  if (
    !equipoIdeal ||
    !equipoIdeal.listaRepo ||
    equipoIdeal.listaRepo.length === 0
  ) {
    return null;
  }

  return (
    <motion.div
      key={variant}
      animate="show"
      initial="hide"
      variants={FADE_IN_OUT}
    >
      <div className="lg:h-auto mt-6 rounded-none lg:rounded-lg bg-white">
        {playersFiltered.map((player: TemplatePlayer, index: number) =>
          player ? (
            <ItemAssistant.IdealTeam
              key={`${player.id ?? 'p'}-${index}`}
              dataPlayerFieldAssistance={getDataFieldPlayer(player.id)}
              templatePlayer={player}
              variant={variant}
            />
          ) : (
            ''
          )
        )}
      </div>
    </motion.div>
  );
};
